import { toEnglishNumber } from "./utility";

export const IrPhoneNumChars = (phonenum: string) => {
  return /^[0][9][0-9][0-9]{8,8}$/.test(toEnglishNumber(phonenum));
};

export const isNumber = (str: string) => {
  try {
    return /^[0-9]+$/.test(toEnglishNumber(str));
  } catch (error) {
    return false;
  }
};
